import React, {useEffect, useRef, useState} from "react";
import {Form, Row, Select, Space, Tabs} from "antd";
import {items} from "./config";
import {tabKeys} from "types/enums";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import "./Allocation.scss";
import {
  setActiveTabAllocation,
  setSearchForm,
} from "redux/reducer/allocationMedicine";

const Allocation = () => {
  const activeKey = useAppSelector(state => state.common.activeTab);
  const activeTabAllocation = useAppSelector(
    state => state.allocationMedicine.activeTabAllocation
  );
  const dispatch = useAppDispatch();

  const onChangeTabList = key => {
    dispatch(setActiveTabAllocation(key));
  };
  return (
    <div className="allocation">
      {/* <div className="container">
        <ExpandSearch
          ref={expandRef}
          onClickSearch={onClickSearchButton}
          fields={inputFields}
        ></ExpandSearch>
      </div> */}
      <div className="">
        <Tabs
          activeKey={activeTabAllocation}
          onChange={onChangeTabList}
          items={items}
        />
      </div>
    </div>
  );
};

export default Allocation;
